import { useMemo, useRef } from 'react';
import { TreeContext } from './context';
import { TreeStore, createTreeStore } from '../../store';
import { useStore } from '@/store';

interface TreeProviderProps extends React.PropsWithChildren {
  id: string;
}

export const TreeProvider = ({ children, id }: TreeProviderProps) => {
  const globalStore = useStore();
  const storeRef = useRef<TreeStore>();

  storeRef.current = useMemo(() => {
    return createTreeStore(globalStore, { id });
  }, [id]);

  return (
    <TreeContext.Provider value={storeRef.current}>
      {children}
    </TreeContext.Provider>
  );
};
